import { useSelector } from 'react-redux';

export const MakeFields = () => {
  const { rut, orderId, sku, cud } = useSelector((state) => state.issuesSlice);

  return [
    {
      name: 'sku',
      label: 'SKU',
      disabled: true,
      required: true,
      value: sku,
      hidden: true,
    },
    {
      name: 'cud',
      label: 'Cud',
      disabled: true,
      required: false,
      value: cud,
      hidden: true,
    },
    {
      name: 'orderId',
      label: 'Oc',
      disabled: true,
      required: true,
      value: orderId,
      hidden: true,
    },
    {
      name: 'rut',
      inputAdornment: '',
      label: 'RUT',
      disabled: true,
      required: true,
      helper: 'Sin puntos, pero con guión Ej: 12345678-9',
      value: rut,
    },
    {
      name: 'clientName',
      inputAdornment: '',
      label: 'Nombre completo',
      disabled: false,
      required: true,
    },
    {
      name: 'phone',
      inputAdornment: '',
      label: 'Teléfono',
      disabled: false,
      required: true,
      helper: 'Ingresar 9 dígitos',
    },
    {
      name: 'email',
      inputAdornment: '',
      label: 'Correo',
      disabled: false,
      required: true,
    },
    {
      name: 'comment',
      inputAdornment: '',
      label: 'Descríbenos el inconveniente',
      disabled: false,
      required: false,
      rows: 4,
      multiline: true,
    },
  ];
};
